// extracted by mini-css-extract-plugin
export default {"cars":"style_cars__xdFA5","header":"style_header__LiHFs","body":"style_body__L5dGG","car":"style_car__7U6mU"};